/**
 * The function `initProductCardColorVariant` initializes color variants for product cards and allows
 * users to change the selected variant.
 * @param elm - The `elm` parameter in the `changeVariant` function represents the element that
 * triggered the event, typically a color variant span element in this case.
 */
var changeVariant = function changeVariant(elm) {
  var _elm$dataset = elm.dataset,
    url = _elm$dataset.url,
    price = _elm$dataset.price,
    compareAtPrice = _elm$dataset.compareAtPrice,
    imageAlt = _elm$dataset.imageAlt;
  var productCard = elm.closest(".product-card");
  var productMedia = JSON.parse(productCard.querySelector('[data-product-media]').textContent);

  // Unselect the variant color from the product card
  productCard.querySelectorAll('.product-card__variant-color').forEach(function (item) {
    item.classList.remove('selected');
  });
  elm.classList.add('selected');

  // Update the product card: pricing and url
  productCard.querySelector('.product-card__price').textContent = price;
  productCard.querySelector('.product-card__compare-at').textContent = compareAtPrice;
  productCard.querySelector('.product-card__images').setAttribute("href", url);

  // Filter the images related to the alt from the variant image alt
  var images = productMedia.filter(function (_ref) {
    var alt = _ref.alt,
      media_type = _ref.media_type;
    return alt === imageAlt && media_type === "image";
  });
  if (images.length < 1) {
    return;
  }
  var imageTags = productCard.querySelectorAll('.product-card-image-swipe img');
  if (imageTags) {
    imageTags.forEach(function (item, index) {
      if (images[index]) {
        item.src = images[index].src + '&width=316';
      } else {
        item.src = images[0].src + '&width=316';
      }
    });
  }
  var imageTag = productCard.querySelector('.product-card-image-zoom img');
  if (imageTag) {
    imageTag.src = images[0].src + '&width=316';
  }
};

/**
 * The function `initProductCardColorVariant` initializes event listeners for color variants on product
 * cards.
 * @returns If the `colorVariant` variable is not found in the document, the function will return early
 * and not execute the rest of the code inside the function.
 */
var initProductCardColorVariant = function initProductCardColorVariant() {
  var colorVariant = document.querySelectorAll(".product-card__variants-color span");
  if (!colorVariant) {
    return;
  }
  colorVariant.forEach(function (item) {
    item.addEventListener("click", function (e) {
      changeVariant(e.target);
    });
  });
};
export { initProductCardColorVariant };